import { Component, Input, OnInit } from '@angular/core';


import { ProjectService } from '../../../../services/project.service';
import { UiService } from '../../../../services/core.ui.service';
import { GfTranslateService } from '../../../../services/core.translate.service';
import { ModalComponent } from '../../../../config/core.modal-helpers';

@Component({
    selector: 'adminDeleteProjectModal',
    template: require('./admin.project-delete.component.html')
})
export class AdminDeleteProjectComponent extends ModalComponent implements OnInit {

    @Input() project: any = null;

    constructor(        
        private projectService: ProjectService,
        private gfTranslateService: GfTranslateService,
        private uiService: UiService
    ) { super(); }

    ngOnInit() { }

    doDelete = () => {

        if (!this.project) this.closeModal();
        var success = false;

        this.projectService.delete(this.project.unixName)
        .then(
            () => {
                this.uiService.message.showSuccess(
                    this.gfTranslateService.translate('Project {{name}} was deleted', this.project),
                    this.gfTranslateService.translate('Delete Project')
                );
                success = true;
            },
            (response) => {
                console.log(response);
                this.uiService.message.showError(
                    this.gfTranslateService.translate('Sorry, could not delete {{name}}', this.project),
                    this.gfTranslateService.translate('Delete Project')
                );
            }
        ).finally(() =>
            this.closeModal(success)
        );
    };
}